/** @jsxImportSource @emotion/react */
import { Box, IconButton, Typography } from '@mui/material'
import { useTheme } from '@mui/material/styles'
import { Icon } from '@app/components/Atoms/Icon'
import { Modal } from '@app/components/Atoms/Modal'
import {
  hazardScenarioDetailsModalContainer,
  hazardScenarioDetailsModalContent,
  hazardScenarioDetailsModalHeader,
  hazardScenarioDetailsModalHeaderInner,
  hazardScenarioDetailsModalHeaderText,
} from './LayerDetailsModal.styles'
import type { MapLayer } from '@app/types/layerTypes'
import { LayerInfo } from '@app/components/Molecules/RiskSideDrawerContent/tabs/InformativePanel/LayersTab/InfoAccordions/LayerInfo/LayerInfo'
import { LayerDetailsReport } from '@app/components/Molecules/RiskSideDrawerContent/data_fetchers/layerDetailsFetcher'

export interface LayerDetailsModalProps {
  layer?: MapLayer
  isOpen: boolean
  layerDetails: LayerDetailsReport[] | null
  handleClose: () => void
}

export const LayerDetailsModal = ({
  isOpen,
  layer,
  layerDetails,
  handleClose,
}: LayerDetailsModalProps) => {
  const theme = useTheme()

  return (
    <Modal open={isOpen} onClose={handleClose}>
      <Box css={hazardScenarioDetailsModalContainer()}>
        <Box css={hazardScenarioDetailsModalHeader({ theme })}>
          <Box css={hazardScenarioDetailsModalHeaderInner()}>
            <Box css={hazardScenarioDetailsModalHeaderText({ theme })}>
              <Icon iconName="Info" />
              <Typography variant="h6" fontWeight={600}>
                Layer Details
              </Typography>
            </Box>

            <IconButton onClick={handleClose}>
              <Icon iconName="Close" />
            </IconButton>
          </Box>
        </Box>
        <Box css={hazardScenarioDetailsModalContent({ theme })}>
          {layer && <LayerInfo layerDetails={layerDetails} />}
        </Box>
      </Box>
    </Modal>
  )
}
